import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../configs/urlConfig";
import "../pages/home.css";
import Utils from "../utils";
const ITEM_HEIGHT = 50;
function generateDatesFromToday() {
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + 2;

  const start = new Date(currentYear - 1, 0, 1);
  const end = new Date(endYear, 11, 31);

  const dates = [];

  let current = new Date(start);
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1; // Aylar 0-11 arasında olduğu için +1 ekliyoruz
  const year = today.getFullYear();
  const todayStr = `${String(day).padStart(2, "0")}.${String(month).padStart(2, "0")}.${year}`;

  while (current <= end) {
    const dd = String(current.getDate()).padStart(2, "0");
    const mm = String(current.getMonth() + 1).padStart(2, "0");
    const yyyy = current.getFullYear();

    // dates.push({date:`${dd}.${mm}.${yyyy}`, date2: `${yyyy}-${mm}-${dd}`});
    dates.push(`${dd}.${mm}.${yyyy}`);
    current.setDate(current.getDate() + 1);
  }
  const index =
    localStorage.getItem("todayIndex") ||
    dates.findIndex((date) => date === todayStr);
  return { dates, todayIndex: index };
}
const ShowDate = ({ showModalDatum, setShowModalDatum }) => {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  //   const [showModalDatum, setShowModalDatum] = useState(false);
  const { dates: date_arr, todayIndex: localIndex } = generateDatesFromToday();
  const [todayIndex, seToDayIndex] = useState(localIndex);
  const [data, setData] = useState([]);

  const getTodayIndex = () => {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const todayStr = `${String(day).padStart(2, "0")}.${String(month).padStart(2, "0")}.${year}`;
    return date_arr.findIndex((date) => date === todayStr);
  };
  const fetchData = async () => {
    try {
      // šaljemo datum u backend
      const response = await axios.get(
        `${API}/get_all_by_day/`,
        Utils.getUserToken(),
      );

      setData(response.data || []); // pretpostavljam da backend vraća objekat sa poljem "payouts"
    } catch (err) {
      console.error(err);
      // setError("Greška prilikom dohvata podataka");
    } finally {
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (!containerRef.current) return;
    const orta = Math.floor(containerRef?.current?.clientHeight / 100);
    containerRef.current.scrollTop = (todayIndex - orta) * ITEM_HEIGHT;
  }, [todayIndex]);

  // Funkcija koja navigira
  const goToDate = (date) => {
    // Format u yyyy-mm-dd
    // const formattedDate = Date(date).toISOString().split("T")[0];
    const arr = date.split(".");
    const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;

    localStorage.setItem(
      "todayIndex",
      date_arr.findIndex((date2) => date2 === date),
    );

    setShowModalDatum(false);

    navigate(`/date/${formattedDate}`);
  };

  return (
    <>
      <div className={`bottom-modal ${showModalDatum ? "show" : ""}`}>
        <div className="modal-header-custom">
          <h4>📅</h4>
          <button
            type="button"
            className="btn btn-primary btn-sm desktop-add-btn"
            onClick={() => {
              const todayIdx = getTodayIndex();
              const orta = Math.floor(
                containerRef?.current?.clientHeight / 100,
              );
              containerRef.current.scrollTo({
                top: (todayIdx - orta) * ITEM_HEIGHT,
                behavior: "smooth",
              });
              seToDayIndex(todayIdx);
              localStorage.setItem("todayIndex", todayIdx);
            }}
          >
            Danas
          </button>
          <button
            className="close-btn"
            onClick={() => setShowModalDatum(false)}
          >
            ✕
          </button>
        </div>

        <div className="modal-body-custom">
          <section className="content-panel mt-1">
            <div
              ref={containerRef}
              className="row g-3"
              style={{ maxHeight: "60vh", overflowY: "auto" }}
            >
              {/* {date_arr.map((dayData, index) => (
                  <div
                    key={index}
                    className={`shadow-sm  border-0 d-flex align-items-center justify-content-center ${index === getTodayIndex() ? "text-white bg-primary bg-opacity-50" : index.toString() === todayIndex ? "bg-secondary bg-opacity-25" : ""}`}
                    style={{ cursor: "pointer", height: "50px", margin: "0px" }}
                    onClick={() => goToDate(dayData)} // <-- klik handler
                  >
                    <h5 className="fw-semibold text-center mb-0">{dayData}</h5>
                  </div>
                ))} */}
              {date_arr.map((dayData, index) => {
                // uzimamo samo dan iz stringa "01.01.2025"
                const dayNumber = dayData.split(".")[0];
                const itemsCount = data[dayNumber];
                // tražimo u data array objekat koji ima isti day
                // const foundDay = data.find((item) => item.day === dayNumber);

                // broj itema
                // const itemsCount = foundDay ? foundDay.items.length : 0;

                return (
                  <div
                    key={index}
                    className={`shadow-sm border-0 d-flex align-items-center justify-content-center 
                      ${
                        index === getTodayIndex()
                          ? "text-white bg-primary bg-opacity-50"
                          : index.toString() === todayIndex
                            ? "bg-secondary bg-opacity-25"
                            : ""
                      }`}
                    style={{
                      cursor: "pointer",
                      height: "50px",
                      margin: "0px",
                    }}
                    onClick={() => goToDate(dayData)}
                  >
                    <h5 className="fw-semibold text-center mb-0 w-100 position-relative">
                      {dayData}
                      <span style={{ position: "absolute", left: "10px" }}>
                        {itemsCount > 0 && `(${itemsCount})`}
                      </span>
                    </h5>
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ShowDate;
